import { KoobButton, KoobCard } from '@koob/ui';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import ToConnectionRequestModelModal from 'containers/ToConnectionRequest/Models/Partials/ToConnectionRequestModelModal';
import { useKoobStore } from '../../../../store';

export default function BulkEditorBottomBar({ loading }) {
  const { t } = useTranslation('toConnectionRequest');
  const form = useFormikContext();
  const [modalMode, setModalMode] = useState(null);
  const clearToConnectionRequestModel = useKoobStore(
    (state) => state.clearToConnectionRequestModel,
  );

  const resetForm = () => {
    form.resetForm();
  };

  const hasSelectedProducts =
    form.values?.request?.toConnectionRequestHotels?.length > 0 ||
    form.values?.request?.toConnectionRequestExperiences?.length > 0 ||
    form.values?.request?.toConnectionRequestTemplates?.length > 0;
  const isFormValid =
    form.values?.toConnectionRequestIds?.length > 0 && hasSelectedProducts;

  const model = form?.values?.model;

  return (
    <>
      <KoobCard>
        <div className="flex justify-between">
          <div className="flex space-x-3">
            <Link
              to={`/to-connection-request/connections`}
              onClick={() => clearToConnectionRequestModel()}
            >
              <KoobButton variant="primary">{t('misc:quit')}</KoobButton>
            </Link>

            <KoobButton
              variant="primary"
              onClick={() => {
                resetForm();
                clearToConnectionRequestModel();
              }}
            >
              {t('misc:resetForm')}
            </KoobButton>
          </div>

          <div className="flex space-x-3">
            <KoobButton
              variant="primary"
              type="button"
              loading={loading}
              disabled={!hasSelectedProducts}
              onClick={() => setModalMode(model ? 'update' : 'create')}
            >
              {model ? t('models.save') : t('models.saveAsModel')}
            </KoobButton>

            {model && (
              <KoobButton
                variant="primary"
                type="button"
                loading={loading}
                disabled={!hasSelectedProducts}
                onClick={() => setModalMode('create')}
              >
                {t('models.saveAsNewModel')}
              </KoobButton>
            )}

            <KoobButton
              variant="primary"
              type="submit"
              loading={loading}
              disabled={!isFormValid}
            >
              {t('bulkEdit.applyButton')}
            </KoobButton>
          </div>
        </div>
      </KoobCard>

      {modalMode && (
        <ToConnectionRequestModelModal
          open={!!modalMode}
          setOpen={(open) => setModalMode(open ? modalMode : null)}
          mode={modalMode}
          model={model}
          connectionRequestData={form.values?.request}
        />
      )}
    </>
  );
}
